<template>
  <v-select
    disabled
    outlined
    dense
    v-model="selected"
    :items="items()"
    item-value="id"
    item-text="label"
    label="Currency"
    @change="$emit('change', selected)"
  />
</template>
<script>
import currencies from '@/configs/currencies'

export default {
  props: {
    init: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      selected: this.init || null
    }
  },
  methods: {
    items() {
      return Object.values(currencies).map(c => {
        // custom label/param only used for the UI
        c.label = `${c.id.toUpperCase()} - ${c.name}`
        return c
      })
    },
  }
}
</script>
